import { Component, OnInit, Inject } from '@angular/core';

// portal
import { environment } from '@open-portal-env';

// service
import { PartnerBrandService } from '@campfire-nx/api';
import { AuthService } from '@open-portal-app/core/services/auth.service';

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(
    private partnerBrandService: PartnerBrandService,
    private authService: AuthService
  ) { }

  // On load, this page redirects user to Auth0 universal logout
  // after logout is done, it will redirect to url provided by param "next"
  // Example of url for logout page:
  //  /logout?next=<Partner's base domain or /login page>
  ngOnInit(): void {
    let url: string;
    const apiKey = this.authService.getApiKey();
    const auth0ClientId = this.partnerBrandService.getAttribute('auth0ClientId', 'partner');
    const companyInfo = this.partnerBrandService.getAttribute('companyInfo', 'partner');

    // redirect to partner's base domain if existing, otherwise go to /login page
    const baseDomainUrl = companyInfo?.BASE_DOMAIN ? `https://${companyInfo.BASE_DOMAIN}` : undefined;
    const loginUrl = `${window.location.origin}/login?partner=${apiKey}&action=dashboard}`;

    if (auth0ClientId) {
      const encoded = baseDomainUrl ? encodeURIComponent(baseDomainUrl) : encodeURIComponent(loginUrl);

      url = `${environment.apiEndpoint}/u/logout?client_id=${auth0ClientId}&next=${encoded}`;
    } else {
      url = baseDomainUrl ? baseDomainUrl : loginUrl;
    }

    this.authService.endSession();

    window.open(url, '_self');
  }

}
